(function () {
  'use strict';

  angular
    .module('dashboard.main')
    .controller('dashboardMainCtrl', dashboardMainCtrl);

  dashboardMainCtrl.$inject = [
    'DashboardMain',
    '$translate',
    '$rootScope',
    '$scope',
    '$timeout',
    'moment',
    'localStorageService',
    '$state',
  ];

  function dashboardMainCtrl(
    DashboardMain,
    $translate,
    $rootScope,
    $scope,
    $timeout,
    moment,
    localStorageService,
    $state,
  ) {
    var vm = this;
    var requestInProgress = false;
    var now = new Date();
    var ttl = 3600000 * 4; // 4 hours
    var colors = [
      '#5793F3',
      '#DD4444',
      '#FEC42C',
      '#D4DF5A',
      '#66bb6a',
      '#5578C2',
      '#ab47bc',
      '#FD9C35',
      '#3949ab',
      '#e91e63',
      '#00bcd4',
      '#DD4D79',
      '#ffeb3b',
      '#8d6e63',
      '#BD3B47',
    ];
    var employeeColors = {};
    var dmTemplates = {
      byDay: [
        [
          '',
          $translate.instant('reports.page.dashboard.new.leads'),
          $translate.instant('reports.page.dashboard.updated.leads'),
        ],
        ['', '#2196f3', '#DD4D79'],
      ],
      byManager: [
        [
          'category',
          'color',
          $translate.instant('reports.page.dashboard.interacted'),
          $translate.instant('reports.page.dashboard.created'),
        ],
      ],
    };
    var CURRENT_VER = 1589210139;

    if ($rootScope.embeddedIntegrationName) {
      $state.go('dashboard.overview');
    }

    vm.showChart = true;
    vm.noData = true;
    vm.periodType = '30';
    vm.lsChartsData = null;
    vm.getDataForChart = getDataForChart;
    vm.dataByDayBeforeFilter = [];
    vm.periodTypes = [
      {
        id: '30',
        name:
          $translate.instant('reports.page.dashboard.last') +
          ' 30 ' +
          $translate.instant('lead.popup.expires.days.full'),
      },
      {
        id: '90',
        name:
          $translate.instant('reports.page.dashboard.last') +
          ' 90 ' +
          $translate.instant('lead.popup.expires.days.full'),
      },
    ];
    vm.yAxisMax = {
      30: '',
      90: '',
    };
    vm.filteredEmployeeName = '';
    vm.chartIsUpdated = true;
    vm.lastUpdatedAt = now;

    function getDataForChart(numOfDays) {
      if (!requestInProgress) {
        requestInProgress = true;
        vm.lsChartsData = localStorageService.get(
          'dashboardInteractionChartsData',
        );
        if (
          (vm.lsChartsData && vm.lsChartsData.ver < CURRENT_VER) ||
          (vm.lsChartsData && typeof vm.lsChartsData.ver === 'undefined')
        ) {
          localStorageService.remove('dashboardInteractionChartsData');
          vm.lsChartsData = null;
        }
        if (
          vm.lsChartsData &&
          typeof vm.lsChartsData.data[numOfDays] !== 'undefined' &&
          vm.lsChartsData.data[numOfDays].expiry > now.getTime()
        ) {
          $timeout(function () {
            mapForChart(vm.lsChartsData.data[numOfDays].values);
            vm.lastUpdatedAt = vm.lsChartsData.data[numOfDays].expiry - ttl;
            requestInProgress = false;
          }, 0);
        } else {
          DashboardMain.getLastXDays({ days: numOfDays }).$promise.then(
            function (response) {
              requestInProgress = false;
              mapForChart(response);
              storeInLocalStorage(response, numOfDays);
            },
            function (error) {
              requestInProgress = false;
            },
          );
        }
      }
    }

    function mapForChart(arr) {
      var dataByManager = [];
      var dataByDay = [];
      if (arr.length) {
        dataByManager = prepDataByManager(arr);
        dataByDay = prepDataByDay(arr);
      }

      $scope.height = 545;
      $scope.width = 900;
      $scope.dataByManager = dataByManager;
      $scope.dataByDay = dataByDay;
      vm.dataByDayBeforeFilter = $scope.dataByDay.slice();
      $timeout(function () {
        vm.noData = false;
      }, 1000);
    }

    function prepDataByManager(arr) {
      var result;
      result = _(arr)
        .groupBy('manager_name')
        .map(function (groupData) {
          return {
            managerName: groupData[0].manager_name,
            newLeads: _.sumBy(groupData, function (i) {
              return parseInt(i.new_leads);
            }),
            interactedLeads: _.sumBy(groupData, function (i) {
              return parseInt(i.interacted_leads);
            }),
          };
        })
        .value();

      assignColorsToEmployees(result);

      result = reformatDataByManager(result);

      return result;
    }

    function prepDataByDay(arr) {
      var result;
      result = _(arr)
        .groupBy('interacted_on')
        .map(function (groupData) {
          return {
            date: groupData[0].interacted_on,
            newLeads: _.sumBy(groupData, function (i) {
              return parseInt(i.new_leads);
            }),
            interactedLeads: _.sumBy(groupData, function (i) {
              return parseInt(i.interacted_leads);
            }),
          };
        })
        .value();

      //findMaxValue(result);

      result = reformatDataByDay(result);

      return result;
    }

    function reformatDataByManager(arr) {
      var data = [];

      data = arr.map(function (obj) {
        return Object.keys(obj).reduce(function (result, key) {
          if (key === 'managerName') {
            result[0] = obj[key];
            result[1] = employeeColors[obj[key]];
          }
          if (key === 'interactedLeads') {
            result[2] = obj[key];
          }
          if (key === 'newLeads') {
            result[3] = obj[key];
          }

          return result;
        }, []);
      });

      data = dmTemplates['byManager'].concat(data);

      return data;
    }

    function reformatDataByDay(arr) {
      var data = [];

      data = arr.map(function (obj) {
        return Object.keys(obj).reduce(function (result, key) {
          if (key === 'date') {
            result[0] = moment(new Date(obj[key])).format('MMM DD, dd');
          }
          if (key === 'newLeads') {
            result[1] = obj[key];
          }
          if (key === 'interactedLeads') {
            result[2] = obj[key];
          }

          return result;
        }, []);
      });

      data = dmTemplates['byDay'].concat(data);

      return data;
    }

    function storeInLocalStorage(response, numOfDays) {
      var obj;
      if (vm.lsChartsData) {
        obj = vm.lsChartsData;
      } else {
        obj = {
          data: {
            30: {
              values: [],
              expiry: 0,
            },
            90: {
              values: [],
              expiry: 0,
            },
          },
          ver: CURRENT_VER,
        };
      }
      obj.data[numOfDays].values = response;
      obj.data[numOfDays].expiry = now.getTime() + ttl;

      localStorageService.set('dashboardInteractionChartsData', obj);
    }

    function findMaxValue(byDayData) {
      if (vm.yAxisMax[vm.periodType] === '') {
        var maxObj = _.maxBy(byDayData, function (i) {
          return parseInt(i.interactedLeads);
        });
        var max = maxObj.interactedLeads;
        max = Math.ceil(parseInt(max) / 10) * 10;
        vm.yAxisMax[vm.periodType] = max.toString();
        $scope.byDayProperties = [
          { name: 'y-axis-max', value: max.toString() },
        ];
      } else {
        $scope.byDayProperties = [
          { name: 'y-axis-max', value: vm.yAxisMax[vm.periodType] },
        ];
      }
    }

    function assignColorsToEmployees(byManagerData) {
      byManagerData.forEach(function (item, i) {
        if (i >= colors.length) {
          employeeColors[item.managerName] = colors[i - 15];
        } else {
          employeeColors[item.managerName] = colors[i];
        }
      });
    }

    $scope.$on('chart.click', function (event, data) {
      if (data.componentType == 'pie') {
        if (
          vm.filteredEmployeeName !== data.data.name ||
          vm.filteredEmployeeName === ''
        ) {
          vm.filteredEmployeeName = data.data.name;
          $scope.dataByManager.forEach(function (array, index) {
            if (index !== 0) {
              array[1] = '#e0e0e0';
            }
            if (
              _.find(array, function (i) {
                return i == data.data.name;
              })
            ) {
              array[1] = employeeColors[data.data.name];
            }
          });
          var originalData = vm.lsChartsData.data[vm.periodType].values;
          var filteredData = _.filter(originalData, function (o) {
            return o.manager_name == data.data.name;
          });
          $scope.dataByDay = prepDataByDay(filteredData);
        } else if (vm.filteredEmployeeName === data.data.name) {
          // remove filter by employee
          vm.filteredEmployeeName = '';
          $scope.dataByManager.forEach(function (array, index) {
            if (index !== 0) {
              array[1] = employeeColors[array[0]];
            }
          });
          $scope.dataByDay = vm.dataByDayBeforeFilter.slice();
        }

        $scope.$broadcast('chart.update');
      }
    });
  }
})();
